import Wrapper from '../Wrapper/Wrapper';
import VerticalSpacer from '../VerticalSpacer/VerticalSpacer';
import React from 'react';
import PropTypes from 'prop-types';
import PressCellLink from './PressCellLink';

const PressCell = props => {
  return (
    <Wrapper margin={'0 22px 0 22px'}>
      <Wrapper
        font={'"Avenir", "Arial", sans-serif'}
        fontSize={props.isDesktop ? '15px' : '13px'}
        color="#999999"
        letterSpacing="1px"
        lineHeight={props.isDesktop ? '20px' : '18px'}
      >{`${props.dateString} - ${props.author} - ${props.country}`}</Wrapper>
      <VerticalSpacer height="3px" />
      <div>
        <PressCellLink isDesktop={props.isDesktop} href={props.url}>
          {props.articleTitle}
        </PressCellLink>
      </div>
    </Wrapper>
  );
};

PressCell.defaultProps = {
  isDesktop: false
};

PressCell.propTypes = {
  isDesktop: PropTypes.bool,
  dateString: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  articleTitle: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};

export default PressCell;
